// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"1979cc88","354":"0c53c7f1","391":"afae0e19","455":"e021a6ef","488":"1a9a8f8c","685":"729ef1fc","977":"3d2c2926"}[chunkId] + ".chunk.js";
};